import React from 'react';

const CustomTopContent = (status: string, percentage: number, amount: number | undefined) => (
  <div>
    <div className="d-flex fw-normal">
      <div className="me-1">{status}</div>
      <div className="text-danger d-flex">
        {percentage >= 0
          ? <div style={percentage === 0 ? { display: 'none' } : { marginTop: '-2px' }}>&#8593;</div>
          : <div style={{ marginTop: '-2px' }}>&#8595;</div>}
        {`${Math.abs(percentage)}%`}
      </div>
    </div>
    <div className="fw-bold fz-20 text-start">
      {amount ? `$${amount.toLocaleString()}` : '0'}
    </div>
  </div>
);

export default CustomTopContent;
